module.exports = __webpack_public_path__ + "img/green-check-round.7620377a.svg";